/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'inv': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.78 22.5V3.75h16.874v1.934H6.563a.938.938 0 00-.938.937V22.5H3.779zM27.187 5.684h-4.659V2.812a.937.937 0 00-.937-.937H2.842a.937.937 0 00-.938.938v20.625c0 .517.42.937.938.937h2.783v2.813c0 .517.42.937.938.937h20.625c.517 0 .937-.42.937-.938V6.622a.937.937 0 00-.938-.937zM7.5 7.559V26.25h18.75V7.559H7.5zm4.352 7.763a.25.25 0 00-.25.25v5.74c0 .139.111.25.25.25h1.609a.25.25 0 00.25-.25v-5.74a.25.25 0 00-.25-.25h-1.61zm3.968-1.332a.25.25 0 01.25-.25h1.61a.25.25 0 01.25.25v7.322a.25.25 0 01-.25.25h-1.61a.25.25 0 01-.25-.25V13.99zm4.47-1.803a.25.25 0 00-.25.25v8.876c0 .138.111.25.25.25h1.608a.25.25 0 00.25-.25v-8.875a.25.25 0 00-.25-.25H20.29z" _fill="#5B6881"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/inv.js